export const TEXTS = {
  MODAL_TITLE: 'Видео-плеер',
  MODAL_CONTENT: 'Какой у вас телевизор?',
  ANDROID_TV: 'Android TV',
  OTHER: 'Другой',
  NEXT: 'Далее',
};
